module.exports = __webpack_public_path__ + "img/sentiment-morenegative.1a11ea81.png";